import ResellerList from "../components/resellerList";
import { Navigate } from "react-router-dom";
import ResellerEditView from "../components/resellerEditView";
import ResellerCreate from "../components/resellerCreate";
import SvgIcons from "../../../shared/components/svgIcons";
const resellerRoutes = [
  {
    path: "resellers",
    element: <ResellerList />,
    link: "resellers",
    name: "Resellers",
    permission: "Reseller",
    icon: SvgIcons.OrganizationIcon,
    index: 3,
  },
  {
    path: "resellers/:id",
    element: <ResellerEditView />,
  },
  {
    path:"resellers/create",
    element: <ResellerCreate />
  },
  {
    path: "*",
    element: <Navigate to="resellers" replace />,
  }
];

export default resellerRoutes;
